import React from 'react';
import PropTypes from 'prop-types';
import MoneyUtils from '@services/money_utils';


class FunnelProgressListCleanerPriceInfo extends React.Component {
    static propTypes = {
        totalPrice: PropTypes.number,
        cleaner: PropTypes.object,
    };

    renderDetailsInfo = () => {
        return (
            <div>
              <div className="little-darkblue-title">
                  {this.props.cleaner.name} {this.price()}
              </div>
            </div>
        );
    };

    renderRequiredAction = () => {
        return (
            <div>
              <div>
                {i18n.t('funnel.breadcrumbs.cleaner-selection.title')}
              </div>
            </div>
        );
    };

    price = () => {
        if(this.props.totalPrice) {
            return (
                <span>
                    - <span className={'price-in-progress-list'}>{MoneyUtils.price(this.props.totalPrice)}</span>
                </span>
                )
        } else {
            return '';
        }
    }

    render() {
        if(this.props.cleaner) {
            return this.renderDetailsInfo();
        }
        else {
            return this.renderRequiredAction();
        }
    }
};

export default FunnelProgressListCleanerPriceInfo;
